import React from "react";
// import { FMarketListData } from "../../../data/foreign/mainBoard/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { useAuth } from "../../../data/auth/hooks";
import { useDisplaySecurityEarnings } from "../../../data/reports/securityStatistics/hooks/useDisplaySecurityEarnings";
import { formatDateFromISO } from "../../../core/util/functions";

export interface DisplaySecurityEarningsProps {
	symbol?: string;
}

export const DisplaySecurityEarnings: React.FunctionComponent<DisplaySecurityEarningsProps> = ({
	symbol,
}) => {
	const earnings = useDisplaySecurityEarnings(symbol);

	const style = useDisplaySingleEmementStyles();
	const { getString, getDateString, getDateTimeString, getFormatedNumberString, getFormatedNumberString4, getPercentString } = React.useContext(
		LocalizationContext
	);

	console.log(earnings)

	const [auth] = useAuth();


	return (
		<div className={style.root}>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("earningsDate")}</span>
				<span className={style.value}>
					{formatDateFromISO(earnings?.date)}
				</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("time")}</span>
				<span className={style.value}>{earnings?.time}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("epsEstimate")}</span>
				<span className={style.value}> {getFormatedNumberString(earnings?.eps_estimate ?? undefined, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("epsActual")}</span>
				<span className={style.value}> {getFormatedNumberString(earnings?.eps_actual ?? undefined, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("difference")}</span>
				<span className={style.value}> {getFormatedNumberString(earnings?.difference ?? undefined, true)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("surprisePercent")}</span>
				<span className={style.value}> {getPercentString(earnings?.surprise_prc ?? undefined)}</span>
			</div>
		</div>
	);
};

